import type Stripe from 'stripe';

export const COUPON_CODE_COOKIE_NAME = 'mill_stripe_coupon';

export function getCouponValue(coupon: Stripe.Coupon) {
	const value = coupon.amount_off ?? coupon.percent_off;

	if (value === null) return 0;

	if (coupon.duration === 'repeating' && coupon.duration_in_months) {
		return value * coupon.duration_in_months;
	}

	return value;
}